import { PlusOutlined, UploadOutlined } from "@ant-design/icons";
import { Button, Modal } from "antd";
import { useState } from "react";
import { Navigate } from "react-router-dom";
import AddBookPublisher from "./addBookPublisher";
import GetAllBookPublisher from "./getAllBookPublisher";
import UploadPublisherExcel from "./UploadPublisherExcel";

const BookPublisher = (props) => {
  const isLogged = Boolean(localStorage.getItem("isLogged"));
  const [addModalOpen, setAddModalOpen] = useState(false);
  const [uploadModalOpen, setUploadModalOpen] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);

  if (!isLogged) {
    return <Navigate to={"/auth/login"} replace={true} />;
  }

  const refreshList = () => {
    setAddModalOpen(false);
    setUploadModalOpen(false);
    setRefreshKey((k) => k + 1);
  };

  const addButton = (
    <Button
      type="primary"
      icon={<PlusOutlined />}
      onClick={() => setAddModalOpen(true)}
      style={{ backgroundColor: "#52c41a", borderColor: "#52c41a", fontWeight: 600 }}
    >
      Add Book Publisher
    </Button>
  );

  const uploadButton = (
    <Button
      icon={<UploadOutlined />}
      onClick={() => setUploadModalOpen(true)}
      style={{ fontWeight: 600 }}
    >
      Import from Excel
    </Button>
  );

  return (
    <div>
      <Modal
        title="Add Book Publisher"
        open={addModalOpen}
        onCancel={() => setAddModalOpen(false)}
        footer={null}
        destroyOnClose
      >
        <AddBookPublisher
          inModal
          onSuccess={refreshList}
          onCancel={() => setAddModalOpen(false)}
        />
      </Modal>
      <Modal
        title="Import from Excel"
        open={uploadModalOpen}
        onCancel={() => setUploadModalOpen(false)}
        footer={null}
        destroyOnClose
      >
        <UploadPublisherExcel onSuccess={refreshList} />
      </Modal>
      <GetAllBookPublisher
        refreshTrigger={refreshKey}
        addBookPublisherButton={addButton}
        uploadButton={uploadButton}
      />
    </div>
  );
};

export default BookPublisher;
